import { runningClientSide } from '@benzinga/utils';

/** When the current page URL includes `ymail`, forward that query param onto outbound CTA links. */
export function withYmailParam(link: string): string {
  if (!runningClientSide()) return link;
  const ymail = new URLSearchParams(window.location.search).get('ymail');
  if (!ymail) return link;
  const url = new URL(link);
  url.searchParams.set('ymail', ymail);
  return url.toString();
}
